import { IRecordFamiliarizationEditItem, RecordFamiliarizationEditItem } from "./recordFamiliarizationEditItem";

export interface IRecordFamiliarizationEdit {
    familiarization: IRecordFamiliarizationEditItem;
}

export class RecordFamiliarizationEdit implements IRecordFamiliarizationEdit {
    familiarization: RecordFamiliarizationEditItem;

    constructor();
    constructor(obj: IRecordFamiliarizationEdit);
    constructor(obj?: any) {
        this.familiarization = new RecordFamiliarizationEditItem(obj ? obj.familiarization : null);
    }
}